/* eslint-disable no-template-curly-in-string */
/**
 * Locked Survey Card
 */

import {
  Flex,
  Heading,
  HStack,
  Link as ChakraLink,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import useAuth from "hooks/useAuth";
import useOpenVerificationModal from "hooks/useOpenVerificationModal";
import {
  ClockIcon,
  InfoIcon,
  SurveyLockedIcon,
} from "../../base/atoms/HJSIcons";
import { useGetSurveysInfoQuery } from "queries";

type TSurveyCard = ({
  surveyIdentifier,
  survey,
}: {
  surveyIdentifier: string;
  survey: any;
}) => JSX.Element;

const LockedSurveyCard: TSurveyCard = ({
  surveyIdentifier,
  survey,
}: {
  surveyIdentifier: string;
  survey: any;
}) => {
  const { completeSms, earnedSmsAmount, totalSms }: { [key: string]: string } =
    survey;
  const shouldOpenVerificationModal = useOpenVerificationModal();
  const { userDetails, isAuthenticated } = useAuth();
  const tooltipLabel1 = `We send a text message survey every 1-2 weeks while you wait for surveys to unlock. You earned $${earnedSmsAmount} for responding to ${completeSms} out of ${totalSms} text message surveys. We'll mail a check for the completed text surveys along with your money for completing this follow up.`;

  const tooltipLabel =
    surveyIdentifier === "followUp1"
      ? `You will earn $25 dollars when you complete this survey. We'll mail a check with your earnings to your registered address.`
      : "You will earn $35 dollars when you complete this survey. We'll mail a check with your earnings to your registered address.";
  // const tooltipLabel2 =
  //   surveyIdentifier === "followUp1" && surveysInfo?.[0]?.isCompleted === false
  //     ? `You will earn $25 dollars when you complete this survey. We'll mail a check with your earnings to your registered address.`
  //     : "You will earn $35 dollars when you complete this survey. We'll mail a check with your earnings to your registered address.";
  return (
    <ChakraLink
      w="full"
      // className={`${
      //   (userDetails?.isEligible as boolean) ? "" : "disable-link"
      // }`}
      _hover={{ textDecor: "none", shadow: "lg" }}
      mt={12}
      onClick={() => shouldOpenVerificationModal()}
    >
      <Flex flexDir="column" overflow="hidden">
        <Flex
          px={[4, 6, 10]}
          py={[4, 5, 6]}
          borderTopLeftRadius="8px"
          borderTopRightRadius="8px"
          bgColor="yellow.500"
          justifyContent="space-between"
        >
          <Heading
            as="h2"
            textTransform="uppercase"
            fontSize={[16, 16, 20, "1.5rem"]}
            color="teal.900"
          >
            {survey.title}
          </Heading>
          <HStack fontSize={[10, 10, 12]}>
            <SurveyLockedIcon
              fill="none"
              boxSize={6}
              height={["14px", 6, 9]}
              width={[3, 6, 8]}
            />
            {userDetails?.layer === 1 ? (
              <Text color="teal.900" fontWeight="700">{`${
                survey.surveyState as string
              } ${
                survey.unlockAt[0] !== "-"
                  ? `- Will unlock in ${survey.unlockAt as string}`
                  : ""
              }`}</Text>
            ) : (
              <Text color="teal.900" fontWeight="700">
                {" "}
                {surveyIdentifier === "followUp1" && isAuthenticated
                  ? "Locked- Will unlock in 28 days after Personality Survey is completed"
                  : surveyIdentifier === "followUp2" && isAuthenticated
                  ? "Locked- Will unlock in 119 days after Personality Survey is completed"
                  : `${survey.surveyState as string} ${
                      survey.unlockAt[0] !== "-"
                        ? `- Will unlock in ${survey.unlockAt as string}`
                        : ""
                    }`}
              </Text>
            )}
          </HStack>
        </Flex>
        <VStack
          flexGrow={1}
          w="full"
          justifyContent="space-between"
          alignItems="flex-start"
          backgroundColor="hjsPrimaryLight"
          borderBottomLeftRadius="8px"
          borderBottomRightRadius="8px"
          py={[5, 6, 7, 10]}
          px={[4, 6, 10]}
          pr="initial !important"
        >
          <Text color="hjsBlack" fontSize="0.75rem" fontWeight="500">
            {survey.description}
          </Text>
          <Flex w="full" justifyContent="space-between" alignItems="center">
            <HStack>
              <ClockIcon
                fill="none"
                boxSize={6}
                color="teal.900"
                height={[4, 4, 5]}
                width={[4, 4, 5]}
              />
              <Text color="teal.900" fontSize={[12, 12, 16]} fontWeight="700">
                Estimated Duration: {survey.estimatedTime}
              </Text>
            </HStack>
            <Flex
              bgColor="teal.600"
              justifyContent="space-around"
              alignItems="center"
              py={2.5}
              borderRadius="4px"
              pr={[2, 3, 4]}
            >
              <Text
                color="white"
                fontWeight="700"
                fontSize={[16, 16, 20]}
                px={[3, 5, 7]}
              >
                $
                {`${survey.earnedCompensation as string} / $${
                  survey.maxSurveyCompensation as string
                }`}
              </Text>

              <Tooltip
                label={
                  userDetails?.layer === 2 || userDetails === null
                    ? tooltipLabel
                    : tooltipLabel1
                }
                placement="top-start"
              >
                <InfoIcon
                  boxSize={6}
                  fill="none"
                  height={[4, 5, 6]}
                  width={[4, 5, 6]}
                />
              </Tooltip>
            </Flex>
          </Flex>
        </VStack>
      </Flex>
    </ChakraLink>
  );
};

export default LockedSurveyCard;
